<template>
  <div>
    <div class="mt-5">
      <form-wizard
        error-color="rgb(242, 19, 93)"
        color="rgba(var(--vs-primary), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
        @on-complete="submitDetails"
        @on-error="handleErrorMessage"
      >
        <!-- tab 2 content -->
        <tab-content
          title="Step 1"
          class="mb-5"
          icon="feather icon-info"
          :before-change="validOne"
        >
          <p>Key In <b>following details</b> and Proceed.</p>
          <div class="vx-row">
            <vs-input
              label="Title"
              v-model="tripInfo.title"
              class="w-full mt-4"
            />
            <vs-input
              label="Invoice Id (Ref num)"
              v-model="tripInfo.invoiceId"
              class="w-full mt-4"
            />
            <label class="vs-input--label">Scheduled Start Date</label>
            <input
              type="date"
              v-model="tripInfo.scheduledStartDate"
              class="w-full mt-5"
            />

            <hr />

            <label class="vs-input--label">Transporter Type</label>
            <v-select
              :options="['IN HOUSE (OWN TRUCK)', 'TRANSPORTER']"
              v-model="tripInfo.transporterType"
              placeholder="Select Transporter Type"
              class="w-full mt-5"
            />

            <div v-if="tripInfo.transporterType == 'IN HOUSE (OWN TRUCK)'">
              <label class="vs-input--label">Assign Driver</label>
              <v-select
                :options="allDrivers"
                placeholder="Assign Driver for Trip"
                v-model="tripInfo.driverId"
                :clearable="false"
                value="id"
                label="id"
              >
                <template slot="option" slot-scope="option" class="w-full mt-5">
                  {{
                    '(Driver Id:' +
                    option.id +
                    ') ' +
                    JSON.parse(option.driverInfo).fullName
                  }}
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option"
                  class="w-full mt-5"
                >
                  {{
                    '(Driver Id:' +
                    option.id +
                    ') ' +
                    JSON.parse(option.driverInfo).fullName
                  }}
                </template>
              </v-select>
              <br />
              <label class="vs-input--label">Assign Truck</label>
              <v-select
                :options="unitSelection"
                placeholder="Assign Truck for Trip"
                v-model="tripInfo.assetId"
                :clearable="false"
                value="assetId"
                label="assetName"
              >
                <template slot="option" slot-scope="option" class="w-full mt-5">
                  {{ option.assetName }}
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option"
                  class="w-full mt-5"
                >
                  {{ option.assetName }}
                </template>
              </v-select>
            </div>

            <div v-if="tripInfo.transporterType == 'TRANSPORTER'">
              <label class="vs-input--label">Assign Transporter</label>
              <v-select
                :options="allTransporters"
                placeholder="Assign Driver for Trip"
                v-model="tripInfo.transporterId"
                :clearable="false"
                value="id"
                label="id"
              >
                <template slot="option" slot-scope="option" class="w-full mt-5">
                  {{
                    '(TS Id:' +
                    option.id +
                    ') ' +
                    JSON.parse(option.tpInfo).name
                  }}
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option"
                  class="w-full mt-5"
                >
                  {{
                    '(TS Id:' +
                    option.id +
                    ') ' +
                    JSON.parse(option.tpInfo).name
                  }}
                </template>
              </v-select>
              <br />
              <div v-if="tripInfo.transporterId != null">
                <label class="vs-input--label">Assign Truck</label>
                <v-select
                  :options="tripInfo.transporterId.tpAssets"
                  placeholder="Assign Driver for Trip"
                  v-model="tripInfo.transporterAssetId"
                  :clearable="false"
                  value="plateNo"
                  label="plateNo"
                >
                  <template
                    slot="option"
                    slot-scope="option"
                    class="w-full mt-5"
                  >
                    {{ option.plateNo }}
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="option"
                    class="w-full mt-5"
                  >
                    {{ option.plateNo }}
                  </template>
                </v-select>
                <br />
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content
          title="Step 2"
          class="mb-5"
          icon="feather icon-info"
          :before-change="validTwo"
        >
          <trip-route
            :userInfo="userInfo"
            :mapPOIData="mapPOIData"
            :geoPOIData="geoPOIData"
            :unitSelection="unitSelection"
            :allClients="allClients"
            :pickups="tripInfo.pickups"
            :groute="tripInfo.groute"
          ></trip-route>
        </tab-content>

        <div class="loader" v-if="loadingWizard"></div>
        <div v-if="errorMsg != ''">
          <span class="error">{{ errorMsg }}</span>
        </div>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import TripRoute from './TripRoute.vue';

import { FormWizard, TabContent } from 'vue-form-wizard';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Query, Predicate } from '@syncfusion/ej2-data';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vSelect from 'vue-select';
import { refreshVirtualFrozenRows } from '@syncfusion/ej2-grids';
import { getBaseURL } from '@/config.js';

export default {
  data() {
    return {
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      geoPOIData: JSON.parse(localStorage.getItem('geoPOIData')),
      quickSelect: null,
      tripInfo: {
        transporterType: '',
        transporterAssets: [],
        pickups: [],
        groute: {},
      },
      allDrivers: [],
      allTransporters: [],
      allClients: [],

      fields: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue: true,
      loadingWizard: false,
      errorMsg: null,
      tpAssets: [],
      refresh: 0,
      industries2: [
        '1 Tonne',
        '2 Tonnes',
        '3 Tonnes',
        '5 Tonnes',
        '5 Tonnes (Box lorry)',
        '10 Tonnes (Loading Capability Of 8 Tonnes)',
        '15 Tonnes (Loading Capability Of 14 Tonnes)',
        '1 tonne',
        '3 / 5 tonne',
        '10 Tonne (Cargo Truck)',
        '10 Tonne Tipper / Crane - 1',
        '20 Tonne Tipper / Crane - 1',
        'Ready Mix',
        'Prime Movers - 1',
        'Prime Movers - 2',
      ],
      industries: [
        'Personal Usage',
        'Agriculture & Farm Product',
        'Construction',
        'Container Handling',
        'Container Haulage',
        'Courier',
        'Drilling Rig Machine',
        'Food Distribution',
        'General Cargo',
        'Manufacturing Raw Materials',
        'Milling Machine',
        'Palm Oil',
        'Pavers',
        'Petro Chemical Tankers',
        'Road Roller',
        'Skid Steer Roller',
        'Stacker',
        'Tractor',
        'Tractor Back Pusher',
        'Utility & Public Services',
      ],
      tpInfo: {
        assetId: -1,
        plate: null,
        type: '',
        subType: '',
        brand: '',
        model: '',
        industry: null,
        class: null,
        vehicleImages: [],
      },
      tpEndpoints: [],
      tpNotifications: [],
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
    };
  },
  watch: {
    tripInfo(val) {
      const self = this;
      if (val.transporterId != null) {
        self.tripInfo.transporterAssets = val.transporterId.tpAssets;
      }
    },
  },
  methods: {
    contactSupport() {
      window.open(
        `https://api.whatsapp.com/send?phone=${this.userInfo.help_whatsapp}&text=Hi%20Igeotechgps%20Support!`,
      );
    },
    driverDocumentsUpload(event, index) {
      this.tpAssets[index].documents.push(JSON.parse(event.xhr.response).path);
      //   console.log(this.tpAssets);
    },
    removeAlarm(index) {
      this.tpAssets.splice(index, 1);
    },
    addAlarm() {
      this.tpAssets.push({
        plateNo: '',
        unitId: '',
        type: '',
        date: '',
        mileage: '',
        documents: [],
        remark: 'Others:-',
      });
    },
    removeAlarm2(index) {
      this.tpEndpoints.splice(index, 1);
    },
    removeNotification(index) {
      this.tpNotifications.splice(index, 1);
    },
    addNotification() {
      this.tpNotifications.push({ type: '', detail: '', remark: '' });
    },
    addAlarm2() {
      this.tpEndpoints.push({
        params: '',
        source: '',
        endpoints: '',
        type: '',
        remark: 'Others:-',
      });
    },
    handleErrorMessage(errorMsg) {
      this.errorMsg = errorMsg;
    },
    vehicleImagesUpload(files, response) {
      this.tpInfo.vehicleImages.push(response.path);
    },

    validOne() {
      return new Promise((resolve, reject) => {
        if (this.tripInfo.title == null || this.tripInfo.title == '') {
          reject('Key in Title. to continue..');
        } else {
          resolve(true);
        }
      });
    },
    validTwo() {
      return new Promise((resolve, reject) => {
        if (this.tripInfo.title == null || this.tripInfo.title == '') {
          reject('Key in Title. to continue..');
        }

        if (this.tripInfo.pickups.length == 0) {
          reject('Add at least 2 points to continue..');
        }
        if (this.tripInfo.groute == null || this.tripInfo.groute == {}) {
          reject('Add at least 2 points & get Route to continue..');
        } else {
          resolve(true);
        }
      });
    },

    formSubmitted() {
      alert('Form submitted!');
    },
    getTripInfo() {
      const self = this;
      self.$http
        .get(`allTripInfo/${self.userInfo.uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.allDrivers = response.data.drivers;
            self.allClients = response.data.clients;
            self.allTransporters = response.data.transporters;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    submitDetails() {
      const self = this;

      self.$http
        .post('trips/submit', {
          userInfo: self.userInfo,
          tripInfo: self.tripInfo,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.$emit('exit', true);
            return self.$vs.notify({
              title: 'New record added',
              text: 'Trip info added!',
              iconPack: 'feather',
              icon: 'icon-refresh-cw',
              color: 'success',
            });
          } else {
            self.$emit('exit', true);
            if (response.data.error) {
              return self.$vs.notify({
                title: 'Error',
                text: response.data.error,
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning',
              });
            } else {
              return self.$vs.notify({
                title: 'Error',
                text: 'Could not created FMS Trip record at this time.Try again later.',
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning',
              });
            }
          }
        })
        .catch(function (error) {
          self.$emit('exit', true);
        });
    },
  },
  mounted() {
    this.getTripInfo();
  },
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect,
    TripRoute,
  },
};
</script>

<style scoped>
@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';

.e-multiselect {
  border-bottom: 1px solid #ffffff;
  font-family: 'Montserrat';
}
.e-multi-select-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  font-family: 'Montserrat';
  height: 40px;
}

.e-multi-select-wrapper-e-delimiter {
  font-family: 'Montserrat';
}
.error {
  color: 'red';
  font-weight: 'bold';
  font-size: '20px';
}
.vs-table {
  overflow-y: visible !important;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
